import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './i18n'; // Initialize i18n before App
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { initMonitoring } from './services/monitoring';
import { logEvent } from './services/analytics';

initMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

// Forward Core Web Vitals to Google Analytics.
reportWebVitals(({ name, delta, id }) => {
  logEvent('Web Vitals', name, id, Math.round(name === 'CLS' ? delta * 1000 : delta));
});
